import { render, staticRenderFns } from "./hadReceiveReward.vue?vue&type=template&id=079f7ae4&scoped=true&"
import script from "./hadReceiveReward.vue?vue&type=script&lang=js&"
export * from "./hadReceiveReward.vue?vue&type=script&lang=js&"
import style0 from "./hadReceiveReward.vue?vue&type=style&index=0&id=079f7ae4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f7ae4",
  null
  
)

component.options.__file = "hadReceiveReward.vue"
export default component.exports